import { Button } from '@mui/material';
import { Fragment, useState } from 'react';
import CallsHistoryDrawer from './CallsHistoryDrawer';

const CallsHistory = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <Fragment>
      <Button
        variant='base'
        size='small'
        sx={{ padding: '6px 12px' }}
        onClick={() => setOpenDrawer(true)}
      >
        <i className='bi bi-telephone' />
      </Button>

      <CallsHistoryDrawer open={openDrawer} setOpen={setOpenDrawer} />
    </Fragment>
  );
};
export default CallsHistory;
